import React from 'react';
import { Reveal } from '../Reveal';
import type { CaseStudy } from '../../types/content';
interface ClientQuoteProps {
  quote: CaseStudy['quote'];
}
export function ClientQuote({
  quote
}: ClientQuoteProps) {
  return <Reveal data-id="element-171" data-mp="36ytfe90ymwxi">
      <figure className="grid gap-8 lg:grid-cols-12 lg:gap-10" data-id="element-172" data-mp="36zbd7a39tj7j">
        <blockquote className="lg:col-span-8" data-id="element-173" data-mp="32xzuzpmq809d">
          <p className="max-w-[36ch] font-serif text-[28px] leading-[1.2] tracking-[-0.03em] text-ink lg:text-[40px]" data-id="element-174" data-mp="32z19k42yb4vu">
            &ldquo;{quote.text}&rdquo;
          </p>
        </blockquote>
        <figcaption className="border-t border-hairline pt-5 lg:col-span-3 lg:col-start-10 lg:border-t-0 lg:pt-0" data-id="element-175" data-mp="2abf56tlwfw7x">
          <span className="block text-small font-medium text-ink" data-id="element-176" data-mp="2o33buhddpshi">{quote.name}</span>
          <span className="mt-1 block text-small text-muted" data-id="element-177" data-mp="2j8z8e83bo2l6">{quote.role}</span>
        </figcaption>
      </figure>
    </Reveal>;
}